import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const RewardsActivity: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="RewardsActivity"
      illustration={
        <svg
          width={restProps.width ?? "48"}
          height={restProps.height ?? "48"}
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M0 24.5C0 11.2452 10.7452 0.5 24 0.5C37.2548 0.5 48 11.2452 48 24.5C48 37.7548 37.2548 48.5 24 48.5C10.7452 48.5 0 37.7548 0 24.5Z"
            fill="#F7D3FF"
          />
          <path
            d="M24.0148 37.5541C24.8531 37.5537 25.6732 37.3183 26.3754 36.8765C27.0776 36.4347 27.6316 35.8056 27.9701 35.0657C28.0092 34.9836 28.0261 34.8933 28.0191 34.8032C28.0122 34.7131 27.9816 34.6262 27.9304 34.5506C27.8791 34.475 27.8088 34.4132 27.726 34.3709C27.6432 34.3287 27.5506 34.3075 27.457 34.3092H20.5725C20.479 34.3077 20.3866 34.3291 20.304 34.3714C20.2214 34.4137 20.1513 34.4756 20.1002 34.5511C20.0491 34.6267 20.0186 34.7135 20.0118 34.8035C20.0049 34.8935 20.0217 34.9837 20.0608 35.0657C20.3992 35.8054 20.953 36.4344 21.6549 36.8761C22.3569 37.3179 23.1767 37.5534 24.0148 37.5541Z"
            fill="#DC3EE0"
          />
          <path
            d="M34.5821 30.2916C34.0444 30.2916 33.5287 30.0855 33.1484 29.7187C32.7682 29.3519 32.5546 28.8544 32.5546 28.3356V21.2292C32.5542 19.3968 31.9207 17.6167 30.7543 16.1704C29.5879 14.7242 27.9551 13.6943 26.1141 13.2436C26.0465 12.7454 25.7931 12.2881 25.4012 11.9572C25.0093 11.6263 24.5058 11.4446 23.985 11.4461C23.4642 11.4475 22.9619 11.6321 22.572 11.9652C22.1821 12.2983 21.9314 12.7571 21.8669 13.2556C20.225 13.6697 18.748 14.546 17.6242 15.7728C16.5003 16.9996 15.7805 18.5215 15.5564 20.1445C15.5564 20.1938 15.5426 20.2419 15.537 20.2912C15.5315 20.3406 15.5218 20.4247 15.5163 20.4914C15.5108 20.5581 15.5052 20.6248 15.4997 20.6902C15.4942 20.7556 15.4928 20.8009 15.49 20.857C15.49 20.9704 15.4817 21.0825 15.4803 21.1972V28.3342C15.4803 28.8505 15.2688 29.3458 14.8919 29.7122C14.515 30.0786 14.0032 30.2864 13.4681 30.2903C13.3424 30.2889 13.2177 30.3114 13.101 30.3565C12.9843 30.4016 12.878 30.4684 12.7881 30.5532C12.6982 30.6379 12.6265 30.7389 12.5771 30.8504C12.5276 30.9619 12.5014 31.0817 12.5 31.2029V31.2109C12.5 31.4551 12.6005 31.6893 12.7795 31.8619C12.9585 32.0346 13.2012 32.1316 13.4543 32.1316H34.5821C34.8287 32.1225 35.0621 32.0216 35.2332 31.8501C35.4044 31.6786 35.5 31.4497 35.5 31.2116C35.5 30.9735 35.4044 30.7447 35.2332 30.5731C35.0621 30.4016 34.8287 30.3007 34.5821 30.2916Z"
            fill="#DC3EE0"
          />
          <circle
            cx="31.0514"
            cy="16.0514"
            r="3.51026"
            fill="#DC3333"
            stroke="#FEC1FF"
            strokeWidth="1.08232"
          />
        </svg>
      }
      {...restProps}
    />
  );
};

export default RewardsActivity;
